/** @type {Map<string, object>} */
const pendingRecordsBySource = new Map();

export const setPendingFilterReferenceRecord = (source, record) => {
    if (source && record?.id != null) {
        pendingRecordsBySource.set(source, record);
    }
};

export const consumePendingFilterReferenceRecord = source => {
    if (!source) {
        return undefined;
    }
    const record = pendingRecordsBySource.get(source);
    pendingRecordsBySource.delete(source);
    return record;
};
